import React, { useState, useEffect } from 'react'
import TabsPageContainer from '../TabsPageContainer'
import { inject } from 'mobx-react'
import { EDITOR_STORE, ALL_LOCATIONS, EDITOR_SHOTS_STORE, EDITOR_LOCATIONS_STORE } from 'store'
import { GroupSideComponent, ShotSideComponent } from 'components'
import GroupViewContent from './GroupViewContent'
import ShotViewContent from './ShotViewContent'
import { observer } from 'mobx-react-lite'
import { TimelineTagsPageProps } from './types'

const tabs = ['group view', 'shot view']

const TimelineTagsPage = (props: TimelineTagsPageProps) => {
  const {
    [EDITOR_STORE]: {
      videoEntityId,
      clearSelectedShotsAndGroups,
      setProjectId
    },
    [EDITOR_SHOTS_STORE]: {
      getVideoShots,
      clearSelectedShots
    },
    [EDITOR_LOCATIONS_STORE]: {
      locationNames,
      selectLocation,
      selectedLocation
    },
    match: { params: { projectId, videoEntityId: paramVideoEntityId } }
  } = props

  useEffect(clearSelectedShotsAndGroups, [])

  const [selectedTab, setSelectedTab] = useState(tabs[0])

  useEffect(() => {
    if (!videoEntityId) {
      getVideoShots(paramVideoEntityId)
      setProjectId(projectId)
    }
  }, [getVideoShots, projectId, paramVideoEntityId, videoEntityId, setProjectId])

  const handleLocationSelect = value => {
    selectLocation(value)
    clearSelectedShots()
  }

  return (
    <TabsPageContainer
      tabs={tabs}
      selectedTab={selectedTab}
      setSelectedTab={setSelectedTab}
      onSelect={clearSelectedShotsAndGroups}
      sideComponent={{
        [tabs[0]]: <GroupSideComponent projectId={parseInt(projectId)}/>,
        [tabs[1]]: <ShotSideComponent projectId={parseInt(projectId)} />
      }[selectedTab] || null}
      filterOptions={{
        [tabs[1]]: [ALL_LOCATIONS, ...locationNames]
      }[selectedTab] || []}
      selectedFilter={selectedLocation}
      onFilterSelect={handleLocationSelect}
    >
      {
        {
          [tabs[0]]: <GroupViewContent />,
          [tabs[1]]: <ShotViewContent />
        }[selectedTab] || null
      }
    </TabsPageContainer>
  )
}

export default inject(EDITOR_STORE, EDITOR_SHOTS_STORE, EDITOR_LOCATIONS_STORE)(observer(TimelineTagsPage))
